import * as yup from "yup";

export const shippopApiKeySchema = yup.object().shape({
  apiKey: yup.string(),
});
